export enum ProgressIndicatorLocation {
  InsideNextButton = 'inside-next-button',
  TopOfTourBlock = 'top-of-tour-block',
  None = 'none',
}
